<template>
  <span class="article_btnConsulta">
    <v-tooltip bottom>
      <v-btn
        slot="activator"
        :loading="loading4"
        :disabled="loading4"
        text-color="white"
        class="d-inline-block bg_white"
        @click.native="consultar()"
        id="btn_consultaAvulsa"
      >
        <span slot="loader" class="TST">
          <small
            class="restante"
            v-if="(logQtd && logQtd >= 10) && hrRestante.busca == true"
          >{{hrRestante.timer}}</small>
          <v-icon class="custom-loader" light v-else>cached</v-icon>
        </span>
        <svg class="customIcon i_header" viewBox="0 0 24 24">
          <path
            fill="#000000"
            d="M12,4C15.64,4 18.67,6.59 19.35,10.04C21.95,10.22 24,12.36 24,15A5,5 0 0,1 19,20H6A6,6 0 0,1 0,14C0,10.91 2.34,8.36 5.35,8.04C6.6,5.64 9.11,4 12,4M7.5,9.69C6.06,11.5 6.2,14.06 7.82,15.68C8.66,16.5 9.81,17 11,17V18.86L13.83,16.04L11,13.21V15C10.34,15 9.7,14.74 9.23,14.27C8.39,13.43 8.26,12.11 8.92,11.12L7.5,9.69M9.17,8.97L10.62,10.42L12,11.79V10C12.66,10 13.3,10.26 13.77,10.73C14.61,11.57 14.74,12.89 14.08,13.88L15.5,15.31C16.94,13.5 16.8,10.94 15.18,9.32C14.34,8.5 13.19,8 12,8V6.14L9.17,8.97Z"
          ></path>
        </svg>
        <small>{{component.name != 'NFSE' ? 'Consulta Sefaz' : 'Consulta Avulsa'}}</small>
      </v-btn>
      <span>{{tooltipMessage}}</span>
    </v-tooltip>
  </span>
</template>

<script>
import NfeService from "@/domain/notas/nfe/NfeService";
import CteService from "@/domain/notas/cte/CteService";
import NfseService from "@/domain/notas/nfse/NfseService";
import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default {
  props: [
    "empresa",
    "table",
    "component",
    "range",
    "conta",
    "logConsulta",
    "logQtd"
  ],
  data: () => ({
    loading4: false,
    loader: null,
    dialog: false,
    qntNovosItens: 0,
    timeout: 6000,
    interval: false,
    text: "Estamos buscando novos itens",
    timer: "",
    tooltipMessage: "Fazer uma busca avulsa por novas notas",
    empresaChamada: "",
    hrRestante: { timer: "", bloq: false }
  }),
  watch: {
    loader() {
      if (!this.interval) {
        this.interval = setInterval(() => {
          try {
            const l = this.loader;
            this[l] = !this[l];

            this.timer = setInterval(() => {
              this[l] = false;
            }, 200000000);
            this.loader = null;
          } catch (error) {
            throw new Error(
              "Erro ao tentar scrollar tabela usando botão" + error
            );
          }
        }, 30);
      }
    },
    "table.buscarNotas": async function(newV, oldV) {
      if (newV) {
        //logica para fazer primeira busca automaticamente
        this.table.buscarNotas = false;
        let i = 0;
        while (i < 3) {
          await this.consultar();
          i++;
        }
      }
    },
    logQtd: function(newV, oldV) {
      this.hrRestante.busca = false;
      if (this.logQtd && this.logQtd == 10) {
        this.relogio(this.logConsulta);
      } else {
        this.loading4 = false;
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {});
  },
  methods: {
    relogio(ultData) {
      // ultData é timeStamp
      var data = new Date(
        `${ultData.getFullYear()}-${ultData.getMonth() +
          1}-${ultData.getDate()} ${ultData.getHours() + 1}:00:00`
      );
      // var data = new Date("Fri Jan 18 2019 11:21:32 GMT-0200");
      var falta = (new Date(data).getTime() - new Date().getTime()) / 1000;
      var segundos = Math.round(falta % 60);
      var minutos = Math.round((falta / 60) % 60);
      var horas = Math.round((falta / 60 / 60) % 24);
      var dias = Math.round(falta / 60 / 60 / 24);
      let auxThis = this;
      if (falta > 0) {
        this.hrRestante.busca = true;
        this.loading4 = true;
        setInterval(function() {
          segundos = parseInt(segundos);
          minutos = parseInt(minutos);
          if (segundos == 0 && minutos > 0) {
            segundos = 60;
            minutos--;
          } else if (segundos == 0 && minutos == 0) {
            auxThis.loading4 = false;
            auxThis.hrRestante.busca = false;
          }
          segundos--;
          if (segundos < 10) {
            segundos = "0" + segundos.toString();
          }
          if (minutos < 10) {
            minutos = "0" + minutos.toString();
          }
          auxThis.hrRestante.timer = `00:${minutos}:${segundos}`;
        }, 1000);
      }
    },
    consultar: async function() {
      this.loader = "loading4";
      this.empresaChamada = this.empresa.razao;
      this.tooltipMessage =
        "Motor fiscal está buscando novas notas para: " + this.empresa.razao;

      if (this.component.name == "NFSE") {
        this.table.snack.text = "Motor fiscal está buscando novas notas";
      } else {
        this.table.snack.text = "Motor fiscal está buscando notas no Sefaz";
      }
      this.table.snackDefault();
      this.table.snack.show = true;
      if (this.component.name.indexOf("NFe") != -1) {
        this.service = new NfeService(this.$http);
      } else if (this.component.name == "CTE") {
        this.service = new CteService(this.$http);
      } else if (this.component.name == "NFSE") {
        this.service = new NfseService(this.$http);
      }
      await this.service
        .consultaAvulsaNota(this.empresa._id, this.component.tipo)
        .then(function(resp) {
          this.table.busca = true;
          if (resp.status == 200) {
            this.qntNovosItens = resp.body.baixadas;
            if (this.qntNovosItens > 0) {
              this.table.loading = true;
              this.table.array_todas_notas = [];
              this.table.time = 7000;
              return this.table.qnt_total_notas + this.qntNovosItens;
            } else {
              if(this.empresa.cnpj && this.empresa.cnpj.length == 11){
                this.table.snack.text = "Motor fiscal está processando as notas, que tal um cafézinho ?";
              }else{
                this.table.snack.text = "Não foram encontradas novas notas.";
              }
              return 0;
            }
          } else if (resp.status == 500 || resp.status == 404) {
            //
            if(resp.body.message == 'Certificado digital não pertence a empresa'){
              this.conta.getEmpresas = true
            }
            this.table.loading = false;
            this.table.snack.text = resp.body.message;
          } else {
            this.table.snack.text =
              "Não conseguimos fazer uma busca, tente mais tarde ou entre em contato";
          }
        })
        .then(novototal => {
          if (novototal > 0) {
            this.table.snack.text =
              this.qntNovosItens == 1
                ? this.qntNovosItens + " nova nota foi encontrada."
                : this.qntNovosItens + " novas notas foram encontradas.";
            let auxThis = this;

            setTimeout(function() {
              auxThis.table.sendAtt = true;
              auxThis.conta.getLog = true;
            }, 5000);
          }
        })
        .then(function() {
          this.table.snack.show = true;

          this.loader = null;

          clearInterval(this.timer);
          this.timer = null;

          clearInterval(this.interval);
          this.interval = false;
          this.timer = false;
          this.loader = null;
          this.loading4 = false;
          this.tooltipMessage = "Fazer uma busca avulsa por novas notas";
        });
    },
    setNotasByHeaders: function(array) {
      switch (this.component.name) {
        case "CTE":
          if (this.table.headers.length > 0) {
            let auxNotas = array;
            let arrayNfe = [];

            let i = 0;
            var cont_c_column = 0;

            while (i < auxNotas.length) {
              let objNfe = {};
              cont_c_column = 0;
              this.table.headers.forEach(item => {
                if (
                  item.value.indexOf("custom") == -1 &&
                  item.value.indexOf("acoes") == -1
                ) {
                  objNfe[item.value] = auxNotas[i][item.value];
                  if (item.show) {
                    document
                      .querySelectorAll(`#${item.value}`)
                      .forEach(item => {
                        item.display = "table-cell";
                        item.removeAttribute("style");
                      });
                  }
                } else if (item.value.indexOf("custom") != -1) {
                  item.value;
                  if (
                    auxNotas[i].customValues != undefined &&
                    auxNotas[i].customValues.length > 0 &&
                    cont_c_column < auxNotas[i].customValues.length &&
                    auxNotas[i].customValues[cont_c_column] != null &&
                    item.value == auxNotas[i].customValues[cont_c_column].key
                  ) {
                    let newObjCustom = {};
                    newObjCustom["value"] =
                      auxNotas[i].customValues[cont_c_column].value;
                    newObjCustom["key"] =
                      auxNotas[i].customValues[cont_c_column].key;
                    objNfe[item.value] = newObjCustom;
                    cont_c_column++;
                  } else {
                    let newObjCustom = {};
                    newObjCustom["value"] = "";
                    newObjCustom["key"] = item.value;
                    objNfe[item.value] = newObjCustom;
                    cont_c_column++;
                  }
                }
              });
              arrayNfe.push(objNfe);
              i++;
            }
            return arrayNfe;
          } else {
            let auxNotas = this.table.arrayNotas.slice();
            let arrayNfe = [];
            let i = 0;
            this.table.headers = this.table.getHeaders();
            while (i < auxNotas.length) {
              let objNfe = {};
              this.table.headers.forEach(item => {
                if (
                  item.value.indexOf("custom") == -1 &&
                  item.value.indexOf("acoes") == -1
                ) {
                  if (item.show) {
                    objNfe[item.value] = auxNotas[i][item.value];
                    document.querySelector(`#${item.value}`).display =
                      "table-cell";
                  }
                } else if (item.value.indexOf("custom") != -1) {
                  objNfe[item.value];
                }
              });
              arrayNfe.push(objNfe);
              i++;
            }
            return arrayNfe;
          }
          break;
        default:
          if (this.table.headers.length > 0) {
            let auxNotas = array;

            let arrayNfe = [];
            let i = 0;
            var cont_c_column = 0;
            while (i < auxNotas.length) {
              let objNfe = {};
              cont_c_column = 0;
              this.table.headers.forEach(item => {
                if (
                  item.value.indexOf("custom") == -1 &&
                  item.value.indexOf("acoes") == -1
                ) {
                  objNfe[item.value] = auxNotas[i][item.value];
                  if (item.show) {
                    document
                      .querySelectorAll(`#${item.value}`)
                      .forEach(item => {
                        item.display = "table-cell";
                        item.removeAttribute("style");
                      });
                  }
                } else if (item.value.indexOf("custom") != -1) {
                  if (
                    auxNotas[i].customValues != undefined &&
                    auxNotas[i].customValues.length > 0 &&
                    cont_c_column < auxNotas[i].customValues.length &&
                    auxNotas[i].customValues[cont_c_column] != null &&
                    item.value == auxNotas[i].customValues[cont_c_column].key
                  ) {
                    let newObjCustom = {};
                    newObjCustom["value"] =
                      auxNotas[i].customValues[cont_c_column].value;
                    newObjCustom["key"] =
                      auxNotas[i].customValues[cont_c_column].key;
                    objNfe[item.value] = newObjCustom;
                    cont_c_column++;
                  } else {
                    let newObjCustom = {};
                    newObjCustom["value"] = "";
                    newObjCustom["key"] = item.value;
                    objNfe[item.value] = newObjCustom;
                    cont_c_column++;
                  }
                }
              });
              arrayNfe.push(objNfe);
              i++;
            }
            return arrayNfe;
          } else {
            let auxNotas = this.table.arrayNotas.slice();
            let arrayNfe = [];
            let i = 0;
            this.table.headers = this.table.getHeaders();
            while (i < auxNotas.length) {
              let objNfe = {};
              this.table.headers.forEach(item => {
                if (
                  item.value.indexOf("custom") == -1 &&
                  item.value.indexOf("acoes") == -1
                ) {
                  if (item.show) {
                    objNfe[item.value] = auxNotas[i][item.value];
                    document.querySelector(`#${item.value}`).display =
                      "table-cell";
                  }
                } else if (item.value.indexOf("custom") != -1) {
                  objNfe[item.value];
                }
              });
              arrayNfe.push(objNfe);
              i++;
            }
            return arrayNfe;
          }
      }
    }
  }
};
</script>
<style scoped>
.lista-colunas {
  width: 46%;
  margin: 0 2% 0 0;
}
.lista-colunas ul {
  height: 40vh;
  list-style-type: none;
  overflow: auto;
}
#colItensAtivas i {
  transform: rotateY(180deg);
}
#btn_consultaAvulsa {
  background: linear-gradient(white, #d3d3d3);
}

.article_btnConsulta {
  cursor: help !important;
}
.article_btnConsulta .restante::before {
  content: "Próx. Consulta:";
  top: -2px;
  position: absolute;
  left: 13%;
  font-weight: bold;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnConsultaAvulsa/BtnConsultaAvulsa.vue